import noop from "lodash/noop";
import { createContext } from "react";
export var NavigationContext = createContext({
  activeRoute: "",
  setActiveRoute: noop,
  isCollapsed: !1,
  expand: noop,
  collapse: noop
});